<script setup lang="ts">
    import { computed, ref } from "vue"
    import type { RouteRecordRaw } from "vue-router"

    interface CurrentMenuItem {
        meta?: { index?: number }
    }

    interface User {
        name?: string | null
        email?: string
        roleName?: string | null
        department?: string | null
    }

    const props = defineProps<{
        items: RouteRecordRaw[]
        subitems: (RouteRecordRaw[] | undefined)[]
        currentItem: CurrentMenuItem
        user: User
    }>()

    const hasUnreadNotification = ref(false)

    /* @type PropOptions */
    const { leftItems, rightItems } = useItemGroup(props)

    function useItemGroup(props: { items: RouteRecordRaw[] }) {
        const leftItems = computed(() => {
            return props.items.filter((item) => item.meta?.position === "left")
        })

        const rightItems = computed(() => {
            return props.items.filter((item) => item.meta?.position === "right")
        })

        return { leftItems, rightItems }
    }
</script>

<script lang="ts">
    export default {
        inheritAttrs: false,
    }
</script>

<template>
    <el-menu
        mode="horizontal"
        :ellipsis="false"
        :default-active="String(currentItem.meta?.index ?? '')"
        class="items-end"
    >
        <h2 class="title">股感CDP數據管理平台</h2>
        <el-menu-item
            v-for="(item, index) in leftItems"
            :key="item.meta?.index"
            data-test="top-navbar-item"
            :index="String(item.meta?.index ?? '')"
            @click="
                () =>
                    $router.push({
                        name: subitems?.[index]?.[0]?.name || item.name,
                    })
            "
        >
            {{ item.meta?.name }}
        </el-menu-item>
        <div class="flex-grow" />
        <el-menu-item
            v-for="item of rightItems"
            :key="item.meta?.index"
            :index="String(item.meta?.index ?? '')"
            data-test="right-navbar-item"
            @click="() => $router.push(item.path ?? '')"
        >
            <BaseSvgIcon
                v-if="item.meta?.icon"
                color="var(--el-color-primary)"
                class="right-navbar-icon"
                :name="item.meta.icon"
            />
            <span class="right-navbar-title"> {{ item.meta?.name }}</span>
        </el-menu-item>
        <div class="logout-popover relative">
            <div
                v-show="hasUnreadNotification"
                class="absolute right-[40%] z-1 w-2 h-2 bg-[#FAAD14] rounded border border-[#ffffff] border-solid"
                data-test="unread-dot"
            ></div>
            <AuthLogoutPopover :user="user" @has-unread="(e: boolean) => (hasUnreadNotification = e)" />
        </div>
    </el-menu>
</template>

<style lang="scss" scoped>
    .title {
        font-size: 16px;
        font-weight: 700;
        line-height: 24px;
        letter-spacing: 0;
        text-align: left;
        padding: 17px 16px;
    }

    .flex-grow {
        flex-grow: 1;
    }

    .logout-popover {
        padding: 13px 20px 13px 0;
    }

    .right-navbar-icon {
        margin-right: 4px;
    }

    .right-navbar-title {
        color: var(--el-color-primary);
    }
</style>
